import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IJobPosition } from '../../shared/interfaces/job-position.interface';

@Injectable({
  providedIn: 'root',
})
export class JobPositionService {
  JobPosition = of([
    {
      codigo_cargo: '0002',
      nombre_cargo: 'Jefe Licencias Medicas',
      descripcion_cargo: 'Gestion de los servicios relacionados a Licencias Medicas',
    },
    {
      codigo_cargo: '0001',
      nombre_cargo: 'referente licencias médicas',
      descripcion_cargo: 'Referente Licencias Medicas',
      dependencia: {
        codigo_cargo: '0001',
        nombre_cargo: 'referente licencias médicas',
        descripcion_cargo: 'Referente Licencias Medicas',
      },
    },
  ]);

  constructor() {}

  listJobPositions() {
    return this.JobPosition;
  }
}
//TODO: comentar
